export const MAX_FILE_SIZE: number = 104900000;
export const MAX_RETRIES: number = 10;
export const PRESIGNED_URLS_EXPIRY = 12000;
export const MAX_CONCURRENT_REQUESTS: number = 40;
export const ONE_KiB = 1_024;
export const ONE_MiB = 1_024 * ONE_KiB;
export const ONE_GiB = 1_024 * ONE_MiB;
export const ONE_TiB = 1_024 * ONE_GiB;
